module.exports = __webpack_public_path__ + "static/demolition-concrete_removal-88bf4f7a25f46de87289988197334d1d.png";